module.exports = __webpack_public_path__ + "f8203b7ac9c70c4594dd7d6b5fed9bce.png";